import type { State } from '../../types';
import type { CompetenceViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function competenceNotDeleted(state: State): CompetenceViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.competenceById ?? {}).filter((e) => !e.deleted);
}
